import { Search, X, SlidersHorizontal } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';

const AdminSearchFilter = ({ 
  searchQuery, 
  onSearchChange, 
  searchPlaceholder = "Search...",
  filters = [], // Array of { key, label, options: [{ value, label }], value, onChange }
  onClearFilters,
  resultCount,
  resultLabel = "items"
}) => {
  const hasActiveFilters = searchQuery || filters.some(f => f.value && f.value !== 'all' && f.value !== '');

  return (
    <div className="mb-6 space-y-3">
      {/* Search Input */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input
          type="text"
          placeholder={searchPlaceholder}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 h-10"
        />
        {searchQuery && (
          <button 
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>

      {/* Filters Row */}
      <div className="flex flex-wrap items-center gap-2">
        {filters.map((filter) => (
          <Select key={filter.key} value={filter.value} onValueChange={filter.onChange}>
            <SelectTrigger className="w-[150px] h-9 text-sm">
              <SlidersHorizontal className="h-3 w-3 mr-2" />
              <SelectValue placeholder={filter.label} />
            </SelectTrigger>
            <SelectContent>
              {filter.options.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        ))}

        {hasActiveFilters && onClearFilters && (
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={onClearFilters}
            className="text-gray-500 h-9"
          >
            <X className="h-3 w-3 mr-1" />
            Clear
          </Button>
        )}

        {resultCount !== undefined && (
          <span className="text-xs text-gray-500 ml-auto">
            {resultCount} {resultLabel}
          </span>
        )}
      </div>
    </div>
  );
};

export default AdminSearchFilter;
